module.exports = function compareDateTime(dateTimeSchedule, date, time) {

  const dateTime1 = new Date(dateTimeSchedule);
  const dateTime2 = new Date(date + "T" + time);

  return (dateTime1.getTime() - dateTime2.getTime()) / 3600000
};
